import BeautyFilterOverlay from 'components/beautyFilter/BeautyFilterOverlay';
import BeautyFilterSkeletons from 'components/beautyFilter/BeautyFilterSkeletons';
import useBeautyFilter from 'hooks/beautyFilter/useBeautyFilter';
import useApplyBeautyFilter from 'hooks/beautyFilter/useApplyBeautyFilter';
import { useRef } from 'react';
import { useEffect } from 'react';

const BeautyFilterModal: React.FC = () => {
  const { isBeautyFilterModalVisible, isLoading, handleBackgroundClick, showSkeletons } = useBeautyFilter();
  useApplyBeautyFilter();
  const isRTL = BResource.isRTL();
  const beuatyFilterModalRef = useRef<any>(null);
  const loadingIconRef = useRef<any>(null);

  useEffect(() => {
    if (isLoading && !loadingIconRef.current) {
      // LoadingIcon 인스턴스 생성 (최대 10초, 파란색, 키 입력 차단)
      loadingIconRef.current = new LoadingIcon('beautyFilterLoading', 0, 'blue', true);
      loadingIconRef.current.show(null, beuatyFilterModalRef.current);
    } else if (!isLoading && loadingIconRef.current) {
      // 로딩이 끝나면 LoadingIcon 숨기기
      loadingIconRef.current.hide();
      loadingIconRef.current = null;
    }
  }, [isLoading]);

  // createPortal() 사용 시 초기 렌더링 시점에는 필요한 모듈이 아직 초기화되지 않은 상태이므로, 모달이 visible 상태일 때만 렌더링하도록 처리
  if (!isBeautyFilterModalVisible) {
    return <></>;
  }

  return (
    <div
      ref={beuatyFilterModalRef}
      dir={isRTL ? 'rtl' : 'ltr'}
      onClick={handleBackgroundClick}
      className="fixed left-0 top-0 z-[110] h-dvh w-dvw max-w-full items-end justify-center overflow-hidden bg-transparent"
    >
      <BeautyFilterOverlay />
      {showSkeletons && <BeautyFilterSkeletons />}
    </div>
  );
};

export default BeautyFilterModal;
